import useUsernameForm from "./UseUsernameForm";

import Input from "@usas/ui-web/components/inputs/Input";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

const UsernameForm = ({ submitButtonText = 'Save', usernameObj, onSubmitFormCallback }) => {
  const {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    resetForm
  } = useUsernameForm(onSubmitFormCallback, usernameObj);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label='Username*'
            name="username"
            value={formState.username}
            error={errorState.username}
            message={errorState.username}
            onChange={(value) => { updateFormState('username', value) }} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="submit">{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={resetForm}>Cancel</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default UsernameForm;